<template>
	<v-combobox
		:class="inputClasses"
		v-if="canAdd"
		:items="items"
		:label="label"
		:hint="hint"
		:disabled="disabled"
		:multiple="multiple"
		:value="selected"
		:small-chips="chips"
		:deletable-chips="chips"
		:placeholder="placeholder"
		:clearable="clearable"
		:append-icon="noSelection ? null : '$dropdown'"
		@input="onInput($event)"
		@change="onChange($event)"
	/>
	<v-autocomplete
		v-else
		:class="inputClasses"
		:items="items"
		:label="label"
		:hint="hint"
		:disabled="disabled"
		:multiple="multiple"
		:small-chips="chips"
		:deletable-chips="chips"
		:value="selected"
		:placeholder="placeholder"
		:clearable="clearable"
		@input="onInput($event)"
		@change="onChange($event)"
	/>
</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			default: () => [],
		},
		disabled: Boolean,
		label: String,
		hint: String,
		chips: Boolean,
		value: [Array, String, Boolean, Number],
		multiple: Boolean,
		placeholder: String,
		canAdd: Boolean,
		noSelection: Boolean,
		clearable: Boolean,
	},
	computed: {
		inputClasses() {
			const classes = []

			if (this.chips) {
				classes.push('input-chipbox')
			}

			return classes
		},
		selected() {
			return this.value
		},
	},
	methods: {
		onInput(event) {
			this.$emit('input', event)
		},
		onChange(event) {
			this.$emit('change', event)
		},
	},
}
</script>

<style scoped>
	.input-chipbox {
		height: 20px;
	}
</style>
